import { useState } from 'react';

export default function useSider() {
  const [isSiderClosing, setIsSiderClosing] = useState(false);
  const [isSiderVisible, setIsSiderVisible] = useState(false);
  const [siderModalToggled, setSiderModalToggled] = useState(false);

  const toggleSiderVisibility = () => {
    setIsSiderVisible((prev) => !prev);
  };

  const closeSiderWithAnimation = () => {
    let id;

    if (!isSiderVisible) {
      toggleSiderVisibility();
      setSiderModalToggled((prev) => !prev);
      return;
    }
    setIsSiderClosing(true);
    setSiderModalToggled((prev) => !prev);
    id = setTimeout(() => {
      toggleSiderVisibility();
      setIsSiderClosing(false);
    }, 300);

    return () => {
      if (id) clearTimeout(id);
    };
  };

  return [
    isSiderVisible,
    isSiderClosing,
    closeSiderWithAnimation,
    siderModalToggled,
  ];
}
